<div
  (tuiActiveZoneChange)="onZoneChange($event)"
  class="py-2"
  *tuiLet="boxAndPlaceQuantityPerClientAddress$ | async as quantity"
>
  <h2 class="font-semibold mb-4 text-[16px]">Адреса разгрузки</h2>
  <div class="flex items-center gap-x-2 rounded-xl mb-2 bg-neutral-100 py-3">
    <div class="w-3/12 pl-2">Клиент</div>
    <div class="w-2/12 text-red-500">Условно!</div>
    <div class="w-3/12">Адрес</div>
    <div class="w-2/12">Коробки</div>
    <div class="w-2/12">Места</div>
  </div>
  <ng-container>
    <div
      *tuiLet="offset$ | async as offset"
      class="drag-n-drop-area"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
    >
      <div
        *ngFor="
          let address of unloadingAddressesForm.controls;
          let index = index
        "
        cdkDrag
        class="flex gap-x-2 py-2 border-b items-center"
      >
        <div class="font-semibold w-3/12 pl-2">
          <span>
            {{ getLetterByIndex(index + (offset ?? 0)) | uppercase }})
          </span>
          {{ address.controls.clientName.getRawValue() }}
        </div>
        <div class="w-2/12">
          <app-checkbox
            [formControl]="address.controls.approximateLocation"
          ></app-checkbox>
        </div>
        <div class="w-3/12">{{ address.controls.address.getRawValue() }}</div>
        <div class="w-2/12">
          {{
            quantity?.[
              getKey(
                address.controls.clientName.getRawValue(),
                address.controls.address.getRawValue()
              )
            ]?.boxQuantity ?? 0
              | number
              | spaceNumber
          }}
        </div>
        <div class="w-2/12">
          {{
            quantity?.[
              getKey(
                address.controls.clientName.getRawValue(),
                address.controls.address.getRawValue()
              )
            ]?.cargoPlaceQuantity ?? 0
              | number
              | spaceNumber
          }}
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div>
  <button appearance="accent" size="s" (click)="viewRoute$.next()" tuiButton>
    Проложить маршрут
  </button>
</div>
